<template lang="pug">
  #app
    b-loading(:active.sync="isLoading" is-full-page)

    template(v-if="user")
      ui-navbar.is-primary(:user="user" :menu="modules" @logout="logout" fixed)
      div
        router-view

    template(v-else-if="!isLoading")
      auth
</template>

<script>
import api from '@/api';
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: 'app',

  data: () => ({
    isLoading: false,
  }),

  computed: {
    ...mapGetters(['user', 'modules']),
  },

  methods: {
    ...mapMutations(['setUser']),

    logout() {
      this.isLoading = true;
      api.logout().finally(() => {
        this.setUser(null);
        this.isLoading = false;
        this.$router.replace('/');
      });
    },
  },
};
</script>

<style lang="scss" src="./assets/app.scss"></style>
